import MetaItem from "../Domain/MetaItem";
import AuthService from "./authService";

export default class MetaService 
{
    static GetMetaList(id) 
    {
        return AuthService.getInstance()
            .CallBackendFunction(`/api/Meta/GetMetaData/${id}`);
    }

    static GetAvailableMetaData(id) 
    {
        return AuthService.getInstance()
            .CallBackendFunction(`/api/Meta/GetAvailableMetaData/${id}`);
    }

    static async AddNewMeta(newItem) 
    {
        var authService = AuthService.getInstance();

        let url = "/api/Meta/PostMetaData";

        return authService.CallBackendFunctionPost(url, JSON.stringify(newItem));
    }

    static RemoveMeta(removeItem) 
    {
        var authService = AuthService.getInstance();

        var url = "/api/Meta/RemoveMetaAsync/";
        return authService.CallBackendFunctionPost(url,JSON.stringify(removeItem));
    }

    static ConvertDBMetaList(metaList) 
    {
        let convertedList = [];

        if (metaList === null || metaList === undefined)
            return convertedList;

        metaList.forEach(item => {
            let newItem = new MetaItem(item)
            convertedList.push(newItem);
        });

        return convertedList;
    }
}